import type { ProductLogoSmallProps } from "../types";

export function ProductLogoSmallIDs({
  size = 20,
  color = "#1874A1",
  ...props
}: ProductLogoSmallProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 480 480"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M216 120.706C251.086 120.706 279.529 149.149 279.529 184.235C279.529 219.322 251.086 247.765 216 247.765C180.914 247.765 152.471 219.322 152.471 184.235C152.471 149.149 180.914 120.706 216 120.706Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M216 36C315.411 36 396 116.589 396 216C396 251.294 385.839 284.215 368.287 312H228C208.118 312 192 328.118 192 348V394.41C103.936 382.677 36 307.274 36 216C36 116.589 116.589 36 216 36ZM216 72C136.471 72 72 136.471 72 216C72 252.057 85.2533 285.019 107.153 310.28C119.25 285.787 144.482 268.941 173.647 268.941H258.353C287.518 268.941 312.749 285.788 324.846 310.28C346.746 285.019 360 252.058 360 216C360 136.471 295.529 72 216 72Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M432 336C438.627 336 444 341.373 444 348V432C444 438.627 438.627 444 432 444H228C221.373 444 216 438.627 216 432V348C216 341.373 221.373 336 228 336H432ZM260 372C255.582 372 252 375.582 252 380V400C252 404.418 255.582 408 260 408H280C284.418 408 288 404.418 288 400V380C288 375.582 284.418 372 280 372H260ZM320 372C315.582 372 312 375.582 312 380V400C312 404.418 315.582 408 320 408H340C344.418 408 348 404.418 348 400V380C348 375.582 344.418 372 340 372H320ZM380 372C375.582 372 372 375.582 372 380V400C372 404.418 375.582 408 380 408H400C404.418 408 408 404.418 408 400V380C408 375.582 404.418 372 400 372H380Z"
        fill={color}
      />
    </svg>
  );
}
